import * as React from 'react';
import { BootstrapTable } from 'react-bootstrap-table';

export interface TableProps {
    data: any;
    children: any;
    onRowClick?: (row: any) => void;
    pagination?: boolean;
    emptyText: string;
}

export function Table (props: TableProps) {
    var options = {
        onRowClick: props.onRowClick,
        noDataText: props.emptyText
    };

    return (
        <BootstrapTable 
            data={props.data} 
            striped={false} 
            hover={true} 
            options={options}            
            bordered={false}
            pagination={props.pagination === undefined ? false : props.pagination}
        >
            {props.children}
        </BootstrapTable>
    );
}

export default Table;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/table/Table.tsx